var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllDealsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 21V4.575C4 4.21858 4.1897 3.88911 4.49793 3.71017L5.48841 3.13517C5.79671 2.95619 6.17697 2.95487 6.4865 3.1317L8.00579 3.9996L9.49389 3.136C9.80305 2.95656 10.1845 2.9558 10.4944 3.134L12 4L13.5056 3.13409C13.8155 2.95589 14.1969 2.95665 14.5061 3.13609L15.9942 3.99968L17.5135 3.13177C17.823 2.95495 18.2033 2.95627 18.5116 3.13525L19.5021 3.71025C19.8103 3.88917 20 4.21861 20 4.575V21",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21H2",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.37346 13.639L8.29456 12.5622C8.02909 12.2972 7.93422 11.906 8.04884 11.5488C8.16346 11.1917 8.4683 10.9287 8.83839 10.8677L10.2628 10.633L11.1175 9.02963C11.2913 8.70365 11.6306 8.5 12 8.5C12.3694 8.5 12.7087 8.70365 12.8824 9.02963L13.7371 10.633L15.1616 10.8677C15.5316 10.9287 15.8365 11.1917 15.9511 11.5488C16.0657 11.906 15.9709 12.2972 15.7054 12.5622L14.6265 13.639L14.8857 15.3482C14.9414 15.7156 14.7888 16.0836 14.4894 16.3037C14.1901 16.5238 13.7933 16.5598 13.4592 16.3972L12 15.6867L10.5407 16.3972C10.2066 16.5598 9.80987 16.5238 9.5105 16.3037C9.21114 16.0835 9.05853 15.7155 9.11424 15.3482L9.37346 13.639Z",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllDealsIcon);
export default __webpack_public_path__ + "static/media/all-deals-icon.aeb001084825dafd44c395f2c9fffd93.svg";
export { ForwardRef as ReactComponent };